import { Component, Input } from '@angular/core';
import { Identity } from '../identity.model';
import { User } from 'src/app/identity/user.model';
import { IdentityService } from 'src/app/identity/identity.service'

@Component({
  selector: 'app-identity-list',
  templateUrl: './identity-list.component.html',
  styleUrls: ['./identity-list.component.sass']
})
export class IdentityListComponent {

  @Input() user!: User;
  @Input() identities?: Identity[];
  currentActiveIdentityCollapsePanel: Identity;

  constructor(
    private identityService: IdentityService
  ) { }

  onChooseAction(action: string) {
    this.identityService.setCurrentView(action);
  }

  setActivePanel(identity: Identity) {
    if (this.currentActiveIdentityCollapsePanel?.pk == identity.pk) {
      this.currentActiveIdentityCollapsePanel = null;
    } else {
      this.currentActiveIdentityCollapsePanel = new Identity(identity);
    }
  }

  updateSizeDiv(identity: Identity) {
    let identityCasted = new Identity(identity);
    var identityType = identity.type;
    if (identityType === 3 || identityType === 4) {
      if (identityCasted.isGovernment() || identityCasted.isManagement()) {
        return "item-scroll long-name"
      } else if (identityCasted.isEmployee()) {
        return "item-scroll very-long-name"
      }
      return "item-scroll medium-name"
    }
    return "item-scroll";
  }

  updateWhiteSpace(identity: Identity){
    var identityType = identity.type;
    if (identityType === 3 || identityType === 4) {
      return 'white-space: normal;';
    }
    return '';
  }

}
